import { useQuery } from '@tanstack/react-query'
import { useCallback } from 'react'
import * as requests from './requests'

export const KEY_GET_PRODUCT_CLASSES = 'getProductClasses'

export const useGetProductClasses = () =>
  useQuery({
    queryKey: [KEY_GET_PRODUCT_CLASSES],
    queryFn: () => requests.getProductClasses(),
    staleTime: 600000,
    meta: {
      errorMessage: 'Erro ao buscar as classes de produto.'
    }
  })

const normalize = (value: string) =>
  value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .toLowerCase()

/**
 * Resolve o id de uma classe pelo nome.
 *
 * O id de cada classe e gerado pelo banco de cada ambiente: as classes criadas
 * pela sincronizacao do catalogo (Alopatico, Higiene e Beleza) nasceram com ids
 * diferentes em desenvolvimento e em producao. Fixar o numero no front faz o
 * filtro devolver lista vazia no ambiente onde o id nao bate -- foi o que
 * aconteceu com class_id 16 e 17. O nome e estavel; o id nao.
 */
export const useProductClassId = () => {
  const { data, isLoading } = useGetProductClasses()

  const getClassIdByName = useCallback(
    (name: string) => data?.classes?.find((item) => normalize(item.name) === normalize(name))?.id,
    [data]
  )

  return { getClassIdByName, isLoading }
}
